import { createContext, ReactNode, useContext, useState } from 'react';

export interface ErrorObject {
  title?: string;
  message: string;
  confirmTitle?: string;
  onConfirm?: () => void;
}

interface ErrorContextProps {
  error: ErrorObject | null;
  setError: (error: ErrorObject | null) => void;
}

const ErrorContext = createContext<ErrorContextProps | undefined>(undefined);

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) throw new Error('useError must be used within an ErrorProvider');
  return context;
};

export const ErrorProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<ErrorObject | null>(null);

  return <ErrorContext.Provider value={{ error, setError }}>{children}</ErrorContext.Provider>;
};
